import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ClickOutHandler from '../OnClickOut';

export default class EnhanceDropdown extends Component {
  state = {
    isOpen: false,
  };

  hide = () => this.setState({ isOpen: false });

  toggle = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));

  render() {
    const { ref, children } = this.props;
    const { isOpen } = this.state;

    return (
      <ClickOutHandler onClickOut={this.hide} ref={ref}>
        {children(isOpen, this.toggle)}
      </ClickOutHandler>
    );
  }
}

EnhanceDropdown.propTypes = {
  children: PropTypes.any,
  ref: PropTypes.func,
};
